/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./crumb.vue?vue&type=template&id=892b891c&scoped=true&"
import script from "./crumb.vue?vue&type=script&lang=js&"
export * from "./crumb.vue?vue&type=script&lang=js&"
import style0 from "./crumb.vue?vue&type=style&index=0&id=892b891c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b891c",
  null
  
)

export default component.exports